<template>
    <div>
        <Loading v-if="loading" type="line" :center="false" />
        <div v-for="rent in rentsDistribution" :key="rent.itemRentId">
            <div v-if="rent.rentNumber" class="div-main"
                :class="{ 'back-danger': rent.status == 1 && !rent.finished, 'back-success': rent.status == 2 && !rent.finished, 'back-warning': rent.status == 3 && !rent.finished, 'back-finished': rent.finished }">
                <div class="molded">
                    <b-row>
                        <b-col sm="2">
                            <Badge :title="'Nº' + rent.rentNumber" type="primary" size="medium" />
                        </b-col>
                        <b-col sm="8">
                            <span class="title"> {{ rent.customerName }}</span>
                        </b-col>
                        <b-col sm="2">
                            <div>
                                <div v-if="!rent.finished">
                                    <IncrementDecrement :min="0" v-model="rent.quantity" :params="rent"
                                        :changed="updateItemMovementBulkId" />
                                </div>
                                <div v-else>
                                    <span>
                                        {{ rent.quantity }}
                                    </span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <div>
                        <small> Identificação {{ rent.identification }}</small>
                    </div>
                    <div>
                        <small>Saída {{ rent.deliveryDateHour | moment("DD/MM/YYYY HH:MM") }}</small>
                        <small> - Início {{ rent.deliveryDateHour | moment("DD/MM/YYYY HH:MM") }}</small>
                        <small> - Fim {{ rent.deliveryDateHour | moment("DD/MM/YYYY HH:MM") }}</small>
                        <small> - Retorno {{ rent.deliveryDateHour | moment("DD/MM/YYYY HH:MM") }}</small>
                    </div>
                    <div>
                        <div v-if="rent.itemRentIdWarning">
                            <div class="div-danger"><i class="fa-solid fa-siren-on icon-red"></i> Atenção, existem
                                produtos reservados que serão utilizados no mesmo período.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="rentsDistribution.length == 0">
            <span>Nenhum registro encontrado!</span>
        </div>
    </div>
</template>

<script>

import Badge from "@nixweb/nixloc-ui/src/component/layout/Badge.vue";
import IncrementDecrement from "@nixweb/nixloc-ui/src/component/forms/IncrementDecrement.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "RentsDistribution",
    props: ['rentsDistribution', 'itemMovementBulk'],
    components: {
        Badge,
        IncrementDecrement,
        Molded,
        Loading
    },
    data() {
        return {
            urlValidation: "/api/v1/operational/items-movement-bulk/validation-rent-distribution",
            itemRentIdSelected: "",
            itemMovementBulkIdSelected: "",
            distributionIdSelected: "",
            quantityOld: 0,
            quantityNew: 0,
            loading: false,
        }
    },
    computed: {
        ...mapState("generic", ["event"]),
    },
    methods: {
        ...mapMutations("generic", ["addEvent"]),
        ...mapActions("generic", ["putApi"]),
        updateItemMovementBulkId(param) {
            this.distributionIdSelected = param.distributionId;
            this.itemRentIdSelected = param.itemRentId;
            this.itemMovementBulkIdSelected = param.itemMovementBulkId;
            this.quantityOld = param.quantity;
        },
        validation() {
            this.loading = true;
            let params = {
                url: this.urlValidation, obj: {
                    distributionId: this.distributionIdSelected,
                    itemRentId: this.itemRentIdSelected,
                    itemMovementBulkId: this.itemMovementBulkIdSelected,
                    rentsDistribution: this.rentsDistribution,
                    quantityOld: this.quantityOld,
                    quantityNew: this.quantityNew,
                    itemMovementBulkResponse: this.itemMovementBulk,
                },
                notNotifyToast: true
            };
            this.putApi(params).then((response) => {
                var status = response.content.status;
                this.loading = false;
                this.addEvent({
                    name: "updateStatusItemBulk",
                    data: { itemMovementBulkId: this.itemMovementBulkIdSelected, response: response.content }
                });
                this.rentsDistribution.forEach(rent => {
                    rent.status = status;
                    rent.itemRentIdWarning = response.content.itemRentIdWarning;
                });
            });
        },
    },
    watch: {
        rentsDistribution: {
            handler(rentsDistribution) {
                const obj = rentsDistribution.find(item => item.distributionId === this.distributionIdSelected);
                this.quantityNew = obj.quantity;
                this.validation();
            },
            deep: true
        },
        event: {
            handler(event) {
                if (event.name == "productBulkUpdate") {
                    console.log("inicio");
                    let self = this;
                    this.rentsDistribution.forEach(rent => {
                        console.log(rent);
                        // NAO ESTA CARREGANDO PORQUE NÃO TEM ITEM NO ARRAY QUE É ACIONADO QUANDO ABRE O MODAL
                        /*     self.distributionIdSelected = rent.distributionId;
                             self.itemRentIdSelected = rent.itemRentId;
                             self.itemMovementBulkIdSelected = rent.itemMovementBulkId;
                             self.quantityOld = rent.quantity;
                             self.quantityNew = rent.quantity;
                             self.validation();*/
                        console.log("aqui");
                    });
                }
            },
            deep: true,
        },
    }
}
</script>
<style scoped>
.div-main {
    margin-bottom: 10px;
}

.molded {
    border: 1px solid #e8eaed;
    border-radius: 10px;
    padding: 10px;
    padding-top: 15px;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 10px;
}

.back-danger {
    background-color: #FFE8E8;
}

.back-warning {
    background-color: #FFFBE6;
}

.back-success {
    background-color: #EBF8F4;
}

.back-finished {
    background-color: #E6F7FF;
}

.div-danger {
    background-color: white;
    border: 1px solid #ffe58f;
    padding: 5px;
    font-size: 12px;
    border-radius: 10px;
}

.icon-red {
    color: red;
}
</style>